import { StandardDialog } from '@ifca-root/react-component/src/components/Dialog/StandardDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	CircularProgress,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	TextField,
} from '@material-ui/core';
import { Check, KeyboardArrowRight, Tune } from '@material-ui/icons';
import AppContext from 'containers/App/Store/AppContext';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import AuditUser from 'assets/icons/audit-user.svg';
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import { formatDate } from 'helpers/formatDate';
import { amtStr } from 'helpers/numFormatter';
import { FilterDialog } from './FilterDialog';
import {
	PosPermission,
	useConsolidatedInvoiceListingQuery,
	useGetAssignedOutletByUserQuery,
	useGetOutletQuery,
} from 'generated/graphql';
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker';
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { OutletIcon } from 'assets';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';

interface Props {
	FilterDialog?: boolean;
	Limit: number;
}

const initialState: Props = {
	FilterDialog: false,
	Limit: 20,
};

const reducer = (state: Props, action: any) => {
	switch (action.type) {
		case 'reset':
			return initialState;
		case 'Limit':
			return { ...state, Limit: action.payload };
		default:
			return { ...state, [action.type]: action.payload };
	}
};

export const ConsolidatedEInvoiceListing = (props: any) => {
	const { mode } = props;

	const consolidatedInvoiceListingSearch = JSON.parse(
		localStorage.getItem('searchFilter'),
	);

	const [filterSearch, setFilterSearch] = useState<string>(
		localStorage.getItem('filterValue') || '',
	);
	window.onbeforeunload = () => {
		localStorage.removeItem('filterValue');
	};

	const { outletID } = useParams<any>();

	const { globalState, dispatch: globalDispatch }: any = useContext(
		AppContext as any,
	);
	const { handlePermDisabled } = usePermissionChecker();

	const [state, dispatch] = useReducer(reducer, initialState);
	const handleDrawer = () => {
		globalDispatch({
			type: 'drawerOpen',
			payload: !globalState.drawerOpen,
		});
	};

	const {
		called: outletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	const {
		fetchMore,
		refetch,
		loading: ConsolidatedInvoiceListingLoading,
		data: { ConsolidatedInvoiceListing } = { ConsolidatedInvoiceListing: [] },
	} = useConsolidatedInvoiceListingQuery({
		fetchPolicy: 'no-cache',
		variables: {
			outletID: outletID,
			accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
			companyID: getOutlet[0]?.companyID,
			startDate:
				null || JSON.parse(localStorage.getItem('filterArgs'))?.startDate,
			endDate: null || JSON.parse(localStorage.getItem('filterArgs'))?.endDate,
			docNo: '' || JSON.parse(localStorage.getItem('filterArgs'))?.docNo,
			docType: '' || JSON.parse(localStorage.getItem('filterArgs'))?.docType,
			offSet: 0,
			limit: 20,
		},
	});

	const history = useHistory();
	const [change, setSwitch] = useState(false);
	const [rerender, setRender] = useState(false);

	const {
		data: { getAssignedOutletByUser } = { getAssignedOutletByUser: [] },
		loading: getAssignedOutletByUserLoading,
	} = useGetAssignedOutletByUserQuery({
		fetchPolicy: 'network-only',
	});

	const [openSwitch, setOpenSwitch] = useState(null);

	const {
		filteredList: filteredList2,
		handleSearch: handleSearch2,
		setOriginalListing: setOriginalListing2,
	} = useFuseSearch();

	useEffect(() => {
		if (
			ConsolidatedInvoiceListing &&
			ConsolidatedInvoiceListing?.length > 0
			// rerender === false
		) {
			setOriginalListing2(ConsolidatedInvoiceListing);
			setRender(true);
		}
	}, [ConsolidatedInvoiceListing]);

	const {
		filteredList: filteredList1,
		handleSearch: handleSearch1,
		setOriginalListing: setOriginalListing1,
	} = useFuseSearch();

	useEffect(() => {
		if (getAssignedOutletByUser && getAssignedOutletByUser?.length > 0) {
			setOriginalListing1(getAssignedOutletByUser);
		}
	}, [getAssignedOutletByUser]);

	const initialValue = () => {
		const savedFilterArgs = JSON.parse(localStorage.getItem('FilterArgs'));
		return {
			startDate:
				JSON.parse(localStorage.getItem('filterArgs'))?.startDate ?? null,
			endDate: JSON.parse(localStorage.getItem('filterArgs'))?.endDate ?? null,
			docNo: JSON.parse(localStorage.getItem('filterArgs'))?.docNo ?? '',
			docType: JSON.parse(localStorage.getItem('filterArgs'))?.docType ?? '',
		};
	};

	const [filterValue, setFilterValue] = useState(initialValue());
	const [openFilterDialog, setOpenFilterDialog] = useState(false);

	const triggerFilterDialogOpen = () => {
		setOpenFilterDialog(true);

		if (JSON.parse(localStorage.getItem('filterArgs'))) {
			setFilterValue({
				startDate:
					null || JSON.parse(localStorage.getItem('filterArgs'))?.startDate,
				endDate:
					null || JSON.parse(localStorage.getItem('filterArgs'))?.endDate,
				docNo: '' || JSON.parse(localStorage.getItem('filterArgs'))?.docNo,
				docType: '' || JSON.parse(localStorage.getItem('filterArgs'))?.docType,
			});
		}
	};

	const triggerFilterDialogClose = () => {
		setOpenFilterDialog(false);
	};

	useEffect(() => {
		if (
			rerender &&
			!ConsolidatedInvoiceListingLoading &&
			!!consolidatedInvoiceListingSearch?.value &&
			ConsolidatedInvoiceListing?.length > 0
		) {
			handleSearch2(`'"${consolidatedInvoiceListingSearch?.value ?? ''}"`, [
				'docNo',
				'description',
			]);
		}
	}, [ConsolidatedInvoiceListingLoading, ConsolidatedInvoiceListing, rerender]);

	return (
		<>
			<MainHeader
				onClick={handleDrawer}
				mainBtn="menu"
				smTitle="Outlet App"
				sideBtn="switch"
				onClickAction={() => setOpenSwitch(true)}
				title={
					getAssignedOutletByUser?.filter(outlet => outlet?.ID === outletID)[0]
						?.name
				}
				// title={user?.companyName}
				routeSegments={[{ name: 'Consolidated e-Invoice', current: true }]}
			/>

			<SearchHeader
				title="Consolidated e-Invoice"
				value={`${ConsolidatedInvoiceListing?.length ?? 0}`}
				onChangeAction={e => {
					handleSearch2(`'"${e?.target?.value}"`, ['docNo', 'description']);
					localStorage.setItem(
						`searchFilter`,
						JSON.stringify({ value: e.target.value }),
					);
				}}
				fixed
				search
				onCloseAction={() => {
					handleSearch2('', []);
					localStorage.removeItem('filterArgs');
					localStorage.removeItem('searchFilter');
				}}
				option={{
					icon: <Tune />,
					onClick: () => {
						triggerFilterDialogOpen();
					},
				}}
			/>

			<ContentWrapper search float>
				<InfiniteScroll
					style={{ overflow: 'inherit' }}
					dataLength={ConsolidatedInvoiceListing?.length}
					next={() => {
						const currentLength = ConsolidatedInvoiceListing?.length;
						fetchMore({
							variables: {
								input: {
									outletID,
								},
								startDate: filterValue?.startDate,
								endDate: filterValue?.endDate,
								docNo: filterValue?.docNo,
								docType: filterValue?.docType,
								offSet: currentLength,
								limit: 10,
							},
							updateQuery: (prev: any, { fetchMoreResult }: any) => {
								if (!fetchMoreResult) return prev;

								return Object.assign({}, prev, {
									getBillInfinite: [
										...prev?.getBillInfinite,
										...fetchMoreResult?.getBillInfinite,
									],
								});
							},
						});
					}}
					hasMore={true}
					className=""
					loader={
						ConsolidatedInvoiceListingLoading && (
							<div style={{ textAlign: 'center' }}>
								<CircularProgress />
							</div>
						)
					}
					endMessage={
						<p style={{ textAlign: 'center' }}>
							<b>-</b>
						</p>
					}
				>
					<List className="core-list rm-padding-infinitescroll">
						{!getAssignedOutletByUserLoading &&
						!ConsolidatedInvoiceListingLoading &&
						(ConsolidatedInvoiceListing === undefined ||
							ConsolidatedInvoiceListing?.length === 0) ? (
							<EmptyList
								title="No Record found"
								subtitle="Please add Consolidated to continue"
							/>
						) : (
							filteredList2?.map((i, index) => (
								<ListItem
									key={index}
									onClick={() =>
										history.push(
											`/menu/outlet-app/${outletID}/consolidate-e-inovoice/view/${i.ID}`,
											{
												Detail: i,
											},
										)
									}
								>
									<ListItemText
										primary={
											<span className="xsTitle flex-space">
												{formatDate(i.docDate)} {i.docNo}
											</span>
										}
										secondary={
											<>
												<span
													className="desc flex-space"
													style={{ fontWeight: 'bold', color: 'black' }}
												>
													{'Type'}
													<br />
													<span
														className="desc"
														style={{ fontWeight: 'bold', color: 'black' }}
													>
														<img
															src={AuditUser}
															alt="ifca"
															width={12}
															loading="lazy"
															style={{ paddingRight: '4px' }}
														/>
														{i?.description}
													</span>
												</span>
												<span
													style={{ fontWeight: 'bold', color: 'black' }}
													className="desc"
												>
													{amtStr(i?.docAmt)}
												</span>
											</>
										}
									/>
									<ListItemSecondaryAction style={{ top: '38px' }}>
										<IconButton
											edge="end"
											onClick={() => {
												localStorage.setItem('filterValue', filterSearch);
												history.push(
													`/menu/outlet-app/${outletID}/consolidate-e-inovoice/view/${i.ID}`,
													{
														Detail: i,
													},
												);
											}}
										>
											<KeyboardArrowRight />
										</IconButton>
									</ListItemSecondaryAction>
								</ListItem>
							))
						)}
					</List>
				</InfiniteScroll>
			</ContentWrapper>

			<FloatButton
				onClick={() =>
					history.push(
						`/menu/outlet-app/${outletID}/consolidate-e-inovoice/add`,
					)
				}
			/>

			<FilterDialog
				setFilterValue={setFilterValue}
				filterValue={filterValue}
				initialValue={initialValue()}
				refetch={refetch}
				open={openFilterDialog}
				close={triggerFilterDialogClose}
			/>

			<CommonDialog
				fullWidth={true}
				open={openSwitch}
				onClose={() => setOpenSwitch(false)}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">{`Switch Outlet`}</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							{getAssignedOutletByUser?.length > 2 ? (
								<TextField
									id="standard-basic"
									label="Search here..."
									fullWidth
									onChange={e => {
										handleSearch1(`'"${e?.target?.value}"`, ['name']);
									}}
								/>
							) : null}
							<ContentWrapper style={{ marginTop: '0px' }}>
								<List>
									{filteredList1?.map((outlet, index) => (
										<>
											<ListItem
												className={
													outlet?.ID === outletID ? 'bg-blue-light' : null
												}
											>
												<div style={{ paddingRight: '6px' }}>
													{outlet?.logo?.fileURL ? (
														<img
															src={outlet?.logo?.fileURL}
															style={{
																display: 'flex',
																marginTop: '2px',
																marginBottom: '2px',
																marginRight: '4px',
																width: '40px',
																height: '40px',
																justifyItems: 'center',
																borderRadius: '30px',
															}}
															loading="lazy"
														/>
													) : (
														<img
															src={OutletIcon}
															style={{
																display: 'flex',
																marginTop: '7px',
																marginBottom: '8px',
																marginRight: '4px',
																width: '40px',
																height: '25px',
																justifyItems: 'center',
																borderRadius: '30px',
															}}
															loading="lazy"
														/>
													)}
												</div>
												<ListItemText
													primary={
														<span className="xsTitle">{outlet?.name}</span>
													}
													onClick={() => {
														history.push(
															`/menu/outlet-app/${outlet?.ID}/consolidate-e-inovoice`,
														);
														setOpenSwitch(false);
														localStorage.setItem('latestOutlet', outlet?.ID);
													}}
												/>
												{outlet?.ID === outletID ? (
													<ListItemSecondaryAction>
														<IconButton edge="end" aria-label="delete">
															<Check color="primary" />
														</IconButton>
													</ListItemSecondaryAction>
												) : null}
											</ListItem>
											<Divider style={{ display: 'flex', width: '100%' }} />
										</>
									))}
								</List>
							</ContentWrapper>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Close',
								props: {
									onClick: () => setOpenSwitch(false),
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
